__turbopack_context__.v({
  "morpher": "MorphingText-module__7sV8qq__morpher",
  "root": "MorphingText-module__7sV8qq__root",
  "text": "MorphingText-module__7sV8qq__text",
  "wordAnim": "MorphingText-module__7sV8qq__wordAnim",
});
